__turbopack_context__.v({
  "setup-message": "QuickSetupMessage-module-scss-module__tVs4iq__setup-message",
});
